import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { Typography } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import {
  allUsers,
  updateBlockStatus,
  track_requirement,
  track_requirement_flags,
} from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Modal, Button } from "@mui/material";
// import { Typography } from '@material-ui/core';
import { Assignment, LocalShipping, Home } from "@material-ui/icons";
import axios from "../api/constant";

import RedeemIcon from "@mui/icons-material/Redeem";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import {
  MDBBtn,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBCard,
  MDBModal,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBCardBody,
  MDBModalBody,
  MDBRow,
  MDBTypography,
} from "mdb-react-ui-kit";
import {
  RejectRequirement,
  updateRequirement,
  modifydetails,
  getdistictName,
  getGPFromDistrictAndBlock,
  requirements,
  school_name_block_wise,
  weo_approval,
  getAllBlocksFromDistrict,
  head_office_secretary_approval,
  dwo_approval,
  dm_approval,
} from "../api/Users";
import {
  subassets,
  getAssetsName,
  AddAsset,
  Assetnameinfo,
  getdistrictName,
  getallDistricts,
  getAmenitiesType,
  getVillageFromGpBlockAndDistrict,
  getSchoolFromVillage,
  getAmenityCountsData,
  getGCB,
  getYearOfConsFromGbcUdise,
} from "../api/Users";
import {
  get_actual_ideal_shortage_count,
  get_allocated_limit_for_amenity_sub_type,
  get_allocated_limit_used_for_amenity_sub_type,
  AddHostelRequirement,
  get_let_long,
} from "../api/Products";

const TrackRequirements = ({ role, userData, mainId }) => {
  const { t } = useTranslation();

  const [markRequired, setMarkRequired] = useState(true);
  const [DistrictName, setDistrictName] = useState([]);

  const [districtDropdown, setDistrictDropdown] = useState("all");
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [AllSchoolNames, setAllSchoolNames] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [track, settrack] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [modalOpen, setModalOpen] = useState(false);
  const [District, setDistrict] = useState("");
  const [Block, setBlock] = useState("");
  const [AssetsType, setAssetsType] = useState([]);
  const [AssetsTypes, setAssetsTypes] = useState([]);
  const [AssetSubtype, setAssetSubtype] = useState("");
  const [AssetsSubTypes, setAssetsSubTypes] = useState([]);
  const [postAmenityName, setPostAmenityName] = useState("");
  const [postAmenitySubName, setPostAmenitySubName] = useState("");
  const [SchoolName, setSchoolName] = useState("");
  const [counts, setCounts] = useState({
    actual_count: 0,
    ideal_count: 0,
    shortage_count: 0,
  });
  const [hostelType, setHostelType] = useState("");
  const [enable, setEnable] = useState(false);
  const [lifespan, setLifeSpan] = useState("");
  const [limits, setLimits] = useState({
    limit_balance: 0,
  });
  const [usedLimits, setUsedLimits] = useState(0);
  const [ExistAssetsType, setExistAssetsType] = useState([]);
  const [DistrictData, setDistrictData] = useState([]);
  const [Allblocks, setAllBlocks] = useState([]);

  const [basicModal, setBasicModal] = useState(false);

  const [Alldistricts, setAllDistricts] = useState([]);

  const toggleShow = () => setBasicModal(!basicModal);
  const [schoolId, setSchoolId] = useState("");

  const [selectedRow, setSelectedRow] = useState(null);
  const [trackFlags, setTrackFlags] = useState({
    DM: 0,
    HM: 0,
    WEO: 0,
    DWO: 0,
    DS: 0,
    DD:0,
  });
  const [trackData, setTrackData] = useState([]);
  // const handleSchoolName = (e) => {
  //   try {
  //     // const selectedSchool = JSON.parse(e.target.value);
  //     setSchoolId(e.target.value);
  //     setPostAmenitySubName([""]);
  //     setPostAmenityName([""]);
  //     // setAssetsType([""]);
  //     // setAssetsTypes([""]);
  //     // setAssetSubtype([""]);

  //     // setSchoolName(selectedSchool.code);
  //     // setPostSchoolname(selectedSchool.school_name);
  //     getAllrequirements(District, Block, e.target.value);
  //   } catch (error) {
  //     console.error("Error parsing JSON in handleSchoolName:", error);
  //   }
  // };
  const handleSchoolName = (e) => {
    try {
      setSchoolId(e.target.value);
      
    } catch (error) {
      console.error("Error parsing JSON in handleSchoolName:", error);
    }
  };
  const handleBlockChange = (e) => {
    console.log(e.target.value);
    const data = {
      block_code: e.target.value,
    };
    school_name_block_wise(data)
      .then((response) => {
        if (response.status == "success") {
          setAllSchoolNames(response.data.result);
        } else {
          setAllSchoolNames([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };

  const getDistictNames = () => {
    getdistictName()
      .then((res) => {
        if (res.status === "success") {
          setDistrictName(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  useEffect(() => {
    getDistictNames();
    console.log(userData);
  }, []);

  const handleDistrictChange = (e) => {
    const selectedDistrictId = e.target.value;
    setDistrict(e.target.value);

    getAllBlocksFromDistrict(selectedDistrictId).then((res) => {
      if (res.status == "success") {
        setAllBlocks(res.data.new_asset_query);
      } else {
        setAllBlocks([]);
      }
    });
    getAllrequirements(selectedDistrictId, Block, schoolId);
  };
  const AssetTypehandle = async (e) => {
    setAssetSubtype("");
    // setAssetSubtype([""]);
    const selectedValue = e.target.value;
    console.log(selectedValue);

    if (!selectedValue) {
      console.error("Empty value received");
      return;
    }

    try {
      const amenities = JSON.parse(selectedValue);
      console.log(amenities);

      const amenityId = amenities.amenity_id;
      setAssetsType(amenityId);

      const amenityName = amenities.name;
      setPostAmenityName(amenityName);

      console.log("AssetsType", amenityId);

      const response = await subassets({ amenity_id: amenityId });
      if (response) {
        console.log(response.data.asset_name);
        setAssetsSubTypes(response.data.asset_name);
      } else {
        console.error("Invalid response format for subassets:", response);
      }
    } catch (error) {
      console.error("Error fetching subassets:", error);
    }
  };
  const AssetSubtypehandle = async (e) => {
    const amenities = JSON.parse(e.target.value);
    setAssetSubtype(amenities.amenity_sub_type_id);
    setPostAmenitySubName(amenities.name);

    if (role === 1) {
      try {
        const postData = {
          amenities_id: AssetsType,
          amenities_sub_type_id: AssetSubtype,
          UDISE_code: SchoolName,
        };

        getAmenityCountsData(postData)
          .then((res) => {
            if (res.status === "success" && res.data.result[0].length > 0) {
              setCounts({
                actual_count:
                  res.data.result[0].actual_count === null
                    ? 0
                    : res.data.result[0].actual_count,
                ideal_count:
                  res.data.result[0].ideal_count === null
                    ? 0
                    : res.data.result[0].ideal_count,
                shortage_count:
                  res.data.result[0].shortage_count === null
                    ? 0
                    : res.data.result[0].shortage_count,
              });
              setEnable(true);
            } else {
              setCounts({
                actual_count: 0,
                ideal_count: 0,
                shortage_count: 0,
              });
            }
          })
          .catch((err) => {
            console.error("Error fetching assets:", err);
          });
      } catch (error) {
        console.error("Error parsing JSON in AssetSubtypehandle:", error);
      }
    } else {
      const data = {
        UDISE_code: userData.data.UDISE_code,
        amenities_id: AssetsType,
        amenities_sub_type_id: amenities.amenity_sub_type_id,
        hostel_id: hostelType,
      };
      get_actual_ideal_shortage_count(data).then((res1) => {
        if (res1.status === "success" && res1.data.result.length > 0) {
          setCounts({
            actual_count: res1.data.result[0].actual_count ?? 0,
            ideal_count: res1.data.result[0].ideal_count ?? 0,
            shortage_count: res1.data.result[0].shortage_count ?? 0,
          });
        } else {
          setCounts({
            actual_count: 0,
            ideal_count: 0,
            shortage_count: 0,
          });
        }
      });

      const limitdata = {
        UDISE_code: userData.data.UDISE_code,
        amenities_id: AssetsType,
        amenities_sub_type_id: amenities.amenity_sub_type_id,
        academic_year: "2023-24",
      };

      const lifespanData = {
        amenities_id: AssetsType,
        amenities_sub_type_id: amenities.amenity_sub_type_id,
      };

      axios.post("/life_span_for_subtype", lifespanData).then((response) => {
        if (response.data.status == "success") {
          setLifeSpan(response.data.data.result[0].life_span);
        }
      });

      get_allocated_limit_for_amenity_sub_type(limitdata).then((res2) => {
        if (res2.status === "success" && res2.data.length > 0) {
          setLimits({
            limit_balance:
              res2.data[0].limit_balance === null
                ? 0
                : parseInt(res2.data[0].limit_balance),
          });
        } else {
          setLimits({
            limit_balance: 0,
          });
        }
      });

      const usedLimitData = {
        amenities_id: AssetsType,
        amenities_sub_type_id: amenities.amenity_sub_type_id,
        UDISE_code: userData.data.UDISE_code,
        academic_year: "2023-24",
      };

      get_allocated_limit_used_for_amenity_sub_type(usedLimitData).then(
        (res3) => {
          if (res3.status === "success" && res3.data.length > 0) {
            setUsedLimits(
              res3.data[0].limit_used === null
                ? 0
                : parseInt(res3.data[0].limit_used)
            );
          } else {
            setUsedLimits(0);
          }
        }
      );

      setEnable(true);
    }
  };
  // const handleBlockChange = (e) => {
  //   setBlock(e.target.value);
  //   setAllSchoolNames([]);
  //   setSchoolName("");

  //   const data = {
  //     block_code: e.target.value,
  //   };
  //   school_name_block_wise(data)
  //     .then((response) => {
  //       if (response.status == "success") {
  //         setAllSchoolNames(response.data.result);
  //       } else {
  //         setAllSchoolNames([]);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching districts:", error);
  //     });
  //   getAllrequirements(District, e.target.value, schoolId);
  // };

  const getAllrequirements = (district, block, school) => {
    setIsLoading(true);
    const data =
      role == 4
        ? {
            role: 4,
            school: userData.data.school_id,
            district: "",
            block: "",
          }
        : role == 8 
        ? {
            role: 8,
            district: district ? district : District ? District : "all",
            block: block ? block : Block ? Block : "all",
            school: school ? school : schoolId ? schoolId : "all",
          }
          : role == 11
        ? {
            role: 11,
            district: district ? district : District ? District : "all",
            block: block ? block : Block ? Block : "all",
            school: school ? school : schoolId ? schoolId : "all",
          }
          : role == 12
        ? {
            role: 12,
            district: district ? district : District ? District : "all",
            block: block ? block : Block ? Block : "all",
            school: school ? school : schoolId ? schoolId : "all",
          }
          : role == 13
        ? {
            role: 13,
            district: district ? district : District ? District : "all",
            block: block ? block : Block ? Block : "all",
            school: school ? school : schoolId ? schoolId : "all",
          }
        : role == 5
        ? {
            role: 5,
            block: userData.data.block_code,
            school: school ? school : schoolId ? schoolId : "all",
          }
        : role == 6
        ? {
            role: 6,
            district: userData.data.district_code,
            block: block ? block : Block ? Block : "all",
            school: school ? school : schoolId ? schoolId : "all",
          }
        : role == 7
        ? {
            role: 7,
            district: userData.data.district_code,
            block: block ? block : Block ? Block : "all",
            school: school ? school : schoolId ? schoolId : "all",
          }
        : {
            role: 3,
            district: district ? district : District ? District : "all",
            block: block ? block : Block ? Block : "all",
            school: school ? school : schoolId ? schoolId : "all",
          };

    requirements(data).then((res) => {
      if (res.status === "success") {
        console.log(res);
        setRows(res.data);
        setFilteredData(res.data);
      } else {
        setRows([]);
        toast.error(t("No Data Available!"));
      }
    });
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    console.log(userData);
    track_requirement(userData.data.school_id, userData.data.UDISE_code)
      .then((response) => {
        if (response.status === "success") {
          settrack(response.data);
          setFilteredData(response.data);
          setIsLoading(false);
        } else {
          settrack([]);
          toast.error(t("Something went wrong"));
          setFilteredData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });


      
  }, []); // Add dependencies here

  // useEffect(() => {
  //   // Call API to fetch districts when the component mounts
  //   axios
  //     .get("/get_all_districts")
  //     .then((response) => {
  //       console.log(response);
  //       if (response.data.status == "success") {
  //         setAllDistricts(response.data.data);
  //       } else {
  //         setAllDistricts([]);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching districts:", error);
  //     });
  // }, []);
  useEffect(() => {
    const data = {
      block_code: userData.data.block_code,
    };
    if (role == 5) {
      school_name_block_wise(data)
        .then((response) => {
          if (response.status == "success") {
            setAllSchoolNames(response.data.result);
          } else {
            setAllSchoolNames([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
        });
    }
  }, [districtDropdown]);

  useEffect(() => {
    if(role==8||role==11||role==12||role==13||role==14){
    getAmenitiesType()
      .then((res) => {
        if (res.status === "success") {
          console.log("amenities data:", res.data);
          setAssetsTypes(res.data);
          setExistAssetsType(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });

    getallDistricts()
      .then((res) => {
        if (res.status === "success") {
          console.log("District Data:", res.data);
          setDistrictData(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching districts:", err);
      });

      getAllBlocksFromDistrict()
      .then((res)=>{
        Allblocks=[];
        if(res.status ==="success"){
          console.log("Block Data :", res.data);
          setAllBlocks(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching blocks:", err);
      });
    }
  }, []);

  // Update filteredData whenever searchQuery changes
  useEffect(() => {
    const filtered = track.filter(
      (item) =>
        (item?.requirement_name &&
          item.requirement_name
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        (item?.id && item.id.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    setFilteredData(filtered);
    setPage(0);
  }, [searchQuery, rows]);

  const [activeStep, setActiveStep] = useState(); // Assuming step 1 is the default active step
  const [approveStep, setapproveStep] = useState(); // Assuming step 1 is the default active step
  const [receivedStep, setreceivedStep] = useState(); // Assuming step 1 is the default active step

  // Fetch hostel data and update progress bar based on hostel ID
  // const fetchAndSetActiveStep = async () => {
  //
  //     try {
  //         const res = await trackreq();
  //         if (res.status === "success" && res.data.length > 0) {
  //             const hostelId = res.data[0].hostel_id;
  //             const approved = res.data[0].is_approve;
  //             const received = res.data[0].is_received
  //             setActiveStep(hostelId); // Update active step based on hostel ID
  //             setapproveStep(approved); // Update active step based on hostel ID
  //             setreceivedStep(received); // Update active step based on hostel ID
  //         }
  //     } catch (error) {
  //         console.error('Error fetching track requirements data: ', error);
  //     }
  // };

  // // Fetch hostel data and set active step when the component mounts
  // useEffect(() => {
  //     fetchAndSetActiveStep();
  // }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 12));
    setPage(0);
  };

  let navigate = useNavigate();
  const view = (id) => {
    navigate(`/${role !== 5 ? "admin" : "dealer"}/admindetails/${id}`);
  };

  const handleUpdateClick = (row) => {
    const data = {
      requirement_id: row.requirement_id,
    };

    track_requirement_flags(data).then((res) => {
      if (res.status == "success") {
        console.log(res);
        setTrackFlags({
          HM: res.data[0].HM_flag,
          WEO: res.data[0].WEO_flag,
          DWO: res.data[0].DWO_flag,
          DM: res.data[0].DWO_flag,
          DS: res.data[0].HO_flag,
          DD:res.data[0].HO_DD,
         
        });
        setTrackData(res.data[0].roles);
      }
    });
    const hostelId = row.school_id;
    const approved = row.is_approve;
    const received = row.is_received;
    setActiveStep(hostelId); // Update active step based on hostel ID
    setapproveStep(approved); // Update active step based on hostel ID
    setreceivedStep(received); // Update active step based on hostel ID
    setSelectedRow(row);
    console.log("selectedRow", selectedRow);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    // Logic to close modal
    setModalOpen(false);
  };

  const handleSelectDistrict = async (e) => {
    setDistrictDropdown(e.target.value);
    // const hostelName = e.target.value;
  };

  useEffect(() => {
    if (role === 6 || role === 7 ) {
      const districtCode = userData.data.district_code;
      getAllBlocksFromDistrict(districtCode)
        .then((res) => {
          if (res.status === "success") {
            setAllBlocks(res.data.new_asset_query);
          } else {
            setAllBlocks([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching blocks:", error);
          setAllBlocks([]);
        });
    }
  }, [role, userData.data.district_code]);



  
  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="my-3">{t("Track Requirements")}</h5>

          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px", // Additional style from your existing code
              }}
            />
          </div>
        </div>

        <div className="Table mb-6">
          <div className="row" style={{ marginTop: "12px" }}>
            <div
              className="col-md-2"
              style={{
                display:
                  role == 8 || role == 11 || role == 12 || role == 13
                    ? "block"
                    : "none",
              }}
            >
              <div style={{ marginRight: "12px" }}>
                <label htmlfor="title" className="form-label">
                  {t("District")}
                </label>
                <select
              name="asset_sub_type"
              onChange={handleDistrictChange}
              className="common-input form-select"
            >
              <option value="all">All</option>
              {DistrictName &&
                DistrictName.map((row, id) => (
                  <option
                    key={id}
                    value={row.district_code}
                    className="text-dark"
                  >
                    {row.name}
                  </option>
                ))}
            </select>
              </div>
            </div>

            <div
              className="col-md-2"
              style={{
                display: role == 4 ? "none" : role == 5 ? "none" : "block",
              }}
            >
              <label className="form-label">{t("Block")} </label>
              <select
                name="GP" // value={AssetsType}
                className="common-input form-select"
                onChange={handleBlockChange}
                required
              >
                <option value="all">All</option>
                {Allblocks &&
                  Allblocks.map((row) => (
                    <option key={row.code} value={row.code}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
            <div
              className="col-md-2"
              style={{ display: role == 4 ? "none" : "block" }}
            >
              <label className="form-label">{t("School Name")} </label>
              <select
              name="SchoolName" // value={AssetsType}
              className="common-input form-select"
              onChange={handleSchoolName}
              required
            >
              <option value="all">All</option>
              {AllSchoolNames &&
                AllSchoolNames.map((row, index) => (
                  <option value={row.school_id}>{row.school_name}</option>
                ))}
            </select>
            </div>
            <div
              className="col-md-2"
              style={{ display: role == 4 ? "none" : "block" }}
            >
              <label className="form-label">
                {t("Amenity Type")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="asset_type_id"
                className="common-input form-select"
                onChange={AssetTypehandle}
                required
              >
                <option value="">{t("Select Amenity Type")}</option>
                {/* Map assetOptions to generate option elements */}
                {AssetsTypes.assets_name &&
                  AssetsTypes.assets_name.map((row, index) => (
                    <option key={index} value={JSON.stringify(row)}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
            <div
              className="col-md-2"
              style={{ display: role == 4 ? "none" : "block" }}
            >
              <label className="form-label">
                {t("Amenity Sub Type")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="asset_sub_type_id"
                onChange={AssetSubtypehandle}
                className="common-input form-select"
                required
              >
                <option value="">{t("Select Amenity Sub Type")}</option>

                {AssetsSubTypes &&
                  AssetsSubTypes.map((row, index) => (
                    <option key={index} value={JSON.stringify(row)}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>

            <button
              className="btn btn-primary btn-sm col-md-2"
              style={{
                marginTop: "35px",
                height: "30px",
                width: "5rem",
                display: role == 4 ? "none" : "block",
              }}
              // onClick={getData}
            >
              {t("Search")}
            </button>
          </div>

          <TableContainer
            component={Paper}
            style={{
              boxShadow: "0px 13px 20px 0px #80808029",
              border: "1px solid gray",
            }}
            className="my-3"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("Requirement")}</TableCell>
                  <TableCell align="left">{t("School Name")}</TableCell>
                  <TableCell align="center">{t("Proposed Quantity")}</TableCell>
                  <TableCell align="center">{t("Updated Quantity")}</TableCell>
                  <TableCell align="center">{t("Proposed Date")}</TableCell>
                  <TableCell align="left">{t("Action")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && track && track.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {track
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell align="left">
                          {row.requirement_name}
                        </TableCell>
                        <TableCell align="left" style={{ width: "15%" }}>
                          {row.school_name}
                        </TableCell>
                        <TableCell align="center">{row.quantity}</TableCell>
                        <TableCell align="center">
                          {row.old_quantity == null
                            ? row.quantity
                            : row.old_quantity}
                        </TableCell>
                        <TableCell align="center">
                          {row.creation_date}
                        </TableCell>
                        <TableCell align="">
                          <Typography
                            variant="button"
                            className="primary-btn btn"
                            id="btn"
                            onClick={() => handleUpdateClick(row)}
                          >
                            {t("Track")}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!track || track.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[12, 25, 50]}
            component="div"
            count={track.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>

      {selectedRow && (
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 1280,
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-5">
              <div>
                <MDBTypography tag="h5" className="mb-3">
                  Approval Tracker
                </MDBTypography>
              </div>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleCloseModal}
                style={{
                  position: "absolute",
                  top: 7,
                  right: 7,
                  background: "none",
                  border: "none",
                  fontSize: 24,
                  cursor: "pointer",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
            <ul
              id="progressbar-2"
              class="d-flex  mx-0 mt-0 mb-6 px-0 pt-0 pb-2"
              style={{ justifyContent: "space-between" }}
            >
              <li
                style={{
                  // marginLeft:
                  //   role==4
                  //   ? "14rem":
                  //   role ==5
                  //   ? "14rem":
                  //   role==6
                  //   ? "14rem":
                  //   "0rem",
                  display:
                    role == 8
                      ? "none"
                      : role == 11
                      ? "none"
                      : role == 12
                      ? "none"
                      : role == 13
                      ? "none"
                      : "block",
                }}
                className={`step0 text-center ${
                  trackFlags.HM == 1 ? "active" : ""
                }`}
              
                id="step2"
              ></li>
              <li
                style={{
                  display:
                 role == 8
                      ? "none"
                      : role == 11
                      ? "none"
                      : role == 12
                      ? "none"
                      : role == 13
                      ? "none"
                      : "block",
                }}
                className={`step0 text-center ${
                  trackFlags.WEO == 1 ? "active" : ""
                }`}
                id="step3"
              ></li>
              
             
              {/* <li
                style={{
                  display:
                    role == 8
                      ? "none"
                      : role == 11
                      ? "none"
                      : role == 12
                      ? "none"
                      : role == 13
                      ? "none"
                      
                      : "block",
                }}
                className={`step0 text-center ${
                  trackFlags.DWO == 1 ? "active" : ""
                }`}
                id="step4"
              ></li> */}
              <li
                style={{

                  width:
                    role == 8
                      ? "33.33%"
                      : role == 11
                      ? "33.33%"
                      : role == 12
                      ? "33.33%"
                      : role == 13
                      ? "33.33%"
                      : "0",
                  marginRight:
                     role == 8
                      ? "0"
                      : role == 11
                      ? "0"
                      : role == 12
                      ? "0"
                      : role == 13
                      ? "0"
                      : "4rem",
                }}
                className={`step0 text-center ${
                  trackFlags.DWO == 1 ? "active" : ""
                }`}
                id="step5"
              ></li>
              <li
                style={{
                  display:
                    role == 3
                      ? "none"
                      : role == 4
                      ? "none"
                      : role == 5
                      ? "none"
                      : role == 6 || role==7
                      ? "none"
                      : "block",
                }}
                className={`step0 text-center ${
                  trackFlags.DS == 1 ? "active" : ""
                }`}
                id="step6"
              ></li>
              <li
                style={{
                  display:
                    role == 3
                      ? "none"
                      : role == 4
                      ? "none"
                      : role == 5
                      ? "none"
                      : role == 6 || role==7
                      ? "none"
                      : "block",
                }}
                className={`step0 text-center ${
                  trackFlags.DD == 1 ? "active" : ""
                }`}
                id="step7"
              ></li>
              <li
                style={{
                  display:
                    role == 3
                      ? "none"
                      : role == 4
                      ? "none"
                      : role == 5
                      ? "none"
                      : role == 6 || role==7
                      ? "none"
                      : "block",
                }}
                className={`step0 text-center ${
                  trackFlags.DD == 1 ? "active" : ""
                }`}
                id="step8"
              ></li>
              <li
                style={{
                  display:
                    role == 3
                      ? "none"
                      : role == 4
                      ? "none"
                      : role == 5
                      ? "none"
                      : role == 6 || role==7
                      ? "none"
                      : "block",
                }}
                className={`step0 text-center ${
                  trackFlags.DD == 1 ? "active" : ""
                }`}
                id="step9"
              ></li>
            </ul>

            <div
              className="d-flex mb-5"
              col-md-12
              style={{
                justifyContent: "flex-start",
              }}
            >
              <div className="d-lg-flex align-items-center">
                <div
                  style={{
                    width:
                      role == 8
                        ? "0"
                        : role == 11
                        ? "0"
                        : role == 12
                        ? "0"
                        : role == 13
                        ? "0"
                        : "",
                    display:
                      role == 8
                        ? "none"
                        : role == 11
                        ? "none"
                        : role == 12
                        ? "none"
                        : role == 13
                        ? "none"
                        : "block",
                  }}
                >
                  <p className="fw-bold mb-2">HM</p>
                  <div className="aprrovalStatus">
                    {trackData.some((data) => data.role_id === 4) ? (
                      trackData.map((data, index) => {
                        if (data.role_id === 4) {
                          return (
                            <React.Fragment key={index}>
                              <p style={{ fontSize: "13px", width:"5.1rem" }}>
                                <span className="fw-bold">A-</span>
                                {data.approved_date}
                              </p>
                              <p style={{ fontSize: "13px", width:"5.1rem"}}>
                                <span className="fw-bold">R-</span>
                                {data.arrival_date}
                              </p>
                            </React.Fragment>
                          );
                        }
                        return null; // Skip rendering for other roles
                      })
                    ) : (
                      <React.Fragment>
                        <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                          <span className="fw-bold">A-</span>
                        </p>
                        <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                          <span className="fw-bold">R-</span>
                        </p>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  width:
                    role == 8
                      ? "0"
                      : role == 11
                      ? "0"
                      : role == 12
                      ? "0"
                      : role == 13
                      ? "0"
                      : "",
                  marginLeft:
                    role == 8
                      ? "0"
                      : role == 11
                      ? "0"
                      : role == 12
                      ? "0"
                      : role == 13
                      ? "0"
                      : "29rem",
                }}
                className="d-lg-flex align-items-center"
              >
                <div
                  style={{
                    display:
                      role == 8
                        ? "none"
                        : role == 11
                        ? "none"
                        : role == 12
                        ? "none"
                        : role == 13
                        ? "none"
                        : "block",
                  }}
                >
                  <p className="fw-bold mb-1 " style={{ marginLeft: "2.8rem" }}>
                    WEO{" "}
                  </p>

                  <div
                    className="aprrovalStatus"
                    style={{ marginLeft: "2rem" }}
                  >
                    {trackData.some((data) => data.role_id === 5) ? (
                      trackData.map((data, index) => {
                        if (data.role_id === 5) {
                          return (
                            <React.Fragment key={index}>
                              <p style={{ fontSize: "13px", width:"5.1rem" }}>
                                <span className="fw-bold">A-</span>
                                {data.approved_date}
                              </p>
                              <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                                <span className="fw-bold">R-</span>
                                {data.arrival_date}
                              </p>
                            </React.Fragment>
                          );
                        }
                        return null; // Skip rendering for other roles
                      })
                    ) : (
                      <React.Fragment>
                        <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                          <span className="fw-bold">A-</span>
                        </p>
                        <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                          <span className="fw-bold">R-</span>
                        </p>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  width:
                    role == 8
                      ? "0"
                      : role == 11
                      ? "0"
                      : role == 12
                      ? "0"
                      : role == 13
                      ? "0"
                      : " ",
                  marginLeft:
                    role == 8
                      ? "0"
                      : role == 11
                      ? "0"
                      : role == 12
                      ? "0"
                      : role == 13
                      ? "0"
                      : "28rem",
                }}
                className="d-lg-flex align-items-center"
              >
                <div
                  className="ms-3"
                  style={{
                    width:
                      role == 8
                        ? "0"
                        : role == 11
                        ? "0"
                        : role == 12
                        ? "0"
                        : role == 13
                        ? "0"
                        : " ",
                    display:
                      role == 8
                        ? "none"
                        : role == 11
                        ? "none"
                        : role == 12
                        ? "none"
                        : role == 13
                        ? "none"
                        : "block",
                  }}
                >
                  <p className="fw-bold mb-0" style={{ marginLeft: "3.2rem" }}>
                    DWO
                  </p>

                  <div
                    className="aprrovalStatus"
                    style={{ marginLeft: "2rem" }}
                  >
                    {trackData.some((data) => data.role_id === 6) ? (
                      trackData.map((data, index) => {
                        if (data.role_id === 6) {
                          return (
                            <React.Fragment key={index}>
                              <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                                <span className="fw-bold">A-</span>
                                {data.approved_date}
                              </p>
                              <p style={{ fontSize: "13px", width:"5.1rem"}}>
                                <span className="fw-bold">R-</span>
                                {data.arrival_date}
                              </p>
                            </React.Fragment>
                          );
                        }
                        return null; // Skip rendering for other roles
                      })
                    ) : (
                      <React.Fragment>
                        <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                          <span className="fw-bold">A-</span>
                        </p>
                        <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                          <span className="fw-bold">R-</span>
                        </p>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
             
              <div
                style={{
                  // marginLeft:
                  //   role == 7
                  //     ? "2rem"
                  //     : role == 8
                  //     ? "9rem"
                  //     : role == 11
                  //     ? "9rem"
                  //     : role == 12
                  //     ? "9rem"
                  //     : role == 13
                  //     ? "9rem"
                  //     : " ",
                }}
                className="d-lg-flex align-items-center"
              >
                <div
                  className="ms-3"
                  style={{
                    display:
                      role == 3
                        ? "none"
                        : role == 4
                        ? "none"
                        : role == 5
                        ? "none"
                        : role == 6 || role==7
                        ? "none"
                        : "block",
                  }}
                >
                  <p className="fw-bold mb-0" >
                    Dy. Sect.
                  </p>
                  <div
                    className="aprrovalStatus"
                    
                  >
                    {trackData.some((data) => data.role_id === 8) ? (
                      trackData.map((data, index) => {
                        if (data.role_id === 8) {
                          return (
                            <React.Fragment key={index}>
                              <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                                <span className="fw-bold">A-</span>
                                {data.approved_date}
                              </p>
                              <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                                <span className="fw-bold">R-</span>
                                {data.arrival_date}
                              </p>
                            </React.Fragment>
                          );
                        }
                        return null; // Skip rendering for other roles
                      })
                    ) : (
                      <React.Fragment>
                        <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                          <span className="fw-bold">A-</span>
                        </p>
                        <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                          <span className="fw-bold">R-</span>
                        </p>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  marginLeft:
                    role == 7
                      ? "3rem"
                      : role == 8
                      ? "15rem"
                      : role == 11
                      ? "15em"
                      : role == 12
                      ? "15rem"
                      : role == 13
                      ? "15rem"
                      : " ",
                }}
                className="d-lg-flex align-items-center"
              >
                <div
                  className="ms-3"
                  style={{
                    display:
                      role == 3
                        ? "none"
                        : role == 4
                        ? "none"
                        : role == 5
                        ? "none"
                        : role == 6
                        ? "none"
                        : "block",
                  }}
                >
                  <p className="fw-bold mb-0" style={{ marginLeft: "3rem" }}>
                    Dy. Dir.
                  </p>
                  <div
                    className="aprrovalStatus"
                    style={{ marginLeft: "2.5rem" }}
                  >
                    {trackData.some((data) => data.role_id === 11) ? (
                      trackData.map((data, index) => {
                        if (data.role_id === 11) {
                          return (
                            <React.Fragment key={index}>
                              <p style={{ fontSize: "13px", width:"5.1rem" }}>
                                <span className="fw-bold">A-</span>
                                {data.approved_date}
                              </p>
                              <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                                <span className="fw-bold">R-</span>
                                {data.arrival_date}
                              </p>
                            </React.Fragment>
                          );
                        }
                        return null; // Skip rendering for other roles
                      })
                    ) : (
                      <React.Fragment>
                        <p style={{ fontSize: "13px"  , width:"5.1rem"}}>
                          <span className="fw-bold">A-</span>
                        </p>
                        <p style={{ fontSize: "13px", width:"5.1rem" }}>
                          <span className="fw-bold">R-</span>
                        </p>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  marginLeft:
                   
                      role == 8
                      ? "16.5rem"
                      : role == 11
                      ? "16.5rem"
                      : role == 12
                      ? "16.5rem"
                      : role == 13
                      ? "16.5rem"
                      : " ",
                }}
                className="d-lg-flex align-items-center"
              >
                <div
                  className="ms-3"
                  style={{
                    display:
                      role == 3
                        ? "none"
                        : role == 4
                        ? "none"
                        : role == 5
                        ? "none"
                        : role == 6 || role==7
                        ? "none"
                        : "block",
                  }}
                >
                  <p
                    className="fw-bold "
                    style={{ marginLeft: "3.5rem", marginBottom: "3rem" }}
                  >
                    Dir.
                  </p>
                  <div
                    className="aprrovalStatus"
                    style={{
                      marginLeft: "2.5rem",
                      position: "relative",
                      top: "-0.8rem",
                    }}
                  >
                    {trackData.some((data) => data.role_id === 11) ? (
                      trackData.map((data, index) => {
                        if (data.role_id === 11) {
                          return (
                            <React.Fragment key={index}>
                              <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                                <span className="fw-bold">R-</span>
                                {data.approved_date}
                              </p>
                            </React.Fragment>
                          );
                        }
                        return null;
                      })
                    ) : (
                      <React.Fragment>
                        <p style={{ fontSize: "13px", width:"5.1rem"}}>
                          <span className="fw-bold">R-</span>
                        </p>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>

              <div
                className="d-lg-flex align-items-center"
                style={{
                  marginLeft:
                    role == 7
                      ? "2rem"
                      : role == 8
                      ? "16.5rem"
                      : role == 11
                      ? "16.5rem"
                      : role == 12
                      ? "16.5rem"
                      : role == 13
                      ? "16.5rem"
                      : " ",
                }}
              >
                <div
                  className="ms-3"
                  style={{
                    display:
                      role == 3
                        ? "none"
                        : role == 4
                        ? "none"
                        : role == 5
                        ? "none"
                        : role == 6
                        ? "none"
                        : "block",
                  }}
                >
                  <p
                    className="fw-bold "
                    style={{ marginLeft: "2.9rem", marginBottom: "3rem" }}
                  >
                    Sect.
                  </p>

                  <div
                    className="aprrovalStatus"
                    style={{ position: "relative", top: "-0.8rem" }}
                  >
                    {trackData.some((data) => data.role_id === 11) ? (
                      trackData.map((data, index) => {
                        if (data.role_id === 11) {
                          return (
                            <React.Fragment key={index}>
                              <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                                <span className="fw-bold">R-</span>
                                {data.approved_date}
                              </p>
                            </React.Fragment>
                          );
                        }
                        return null;
                      })
                    ) : (
                      <React.Fragment>
                        <p style={{ fontSize: "13px" , width:"5.1rem"}}>
                          <span className="fw-bold">R-</span>
                        </p>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

      )}
      
    </>
  );
};

export default TrackRequirements;
